export default {
  id: 206,
  title: 'Target #206 - Punisher',
  url: 'https://cssbattle.dev/play/206',
  colors: ['#000000', '#CAE5DC'],
  solution:
    '<p a><p b><p c><p d><p e><p f><style>p[a],p[b],p[c]{background:#000}p[d],p[e]{top:119;width:46;height:23;background:#cae5dc;border-radius:0 0 1in 1in}body{background:#cae5dc}p{position:fixed;margin:0}p[a]{top:40;left:130;width:140;height:140;border-radius:1in}p[b]{top:150;left:150;width:100;height:30}p[c]{top:180;left:162;width:16;height:93;box-shadow:20px 0,40px 0,60px 0}p[d]{left:139;rotate:28deg}p[e]{right:139;rotate:-28deg}p[f]{top:136;left:189.5;border-style:solid;border-color:#cae5dc #000;border-width:0 10px 30px',
}
